import { useEffect, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { TextInput } from '~/components/ui/TextInput';
import { useWalletIcon } from '~/hooks';
import { Currency } from '~/shared';
import { StyledContainer } from './MoneyInput.styled';

interface IMoneyInputProps extends React.HTMLAttributes<HTMLDivElement> {
	value?: number;
	readonly?: boolean;
	changeHandler?: any;
	currency: Currency;
}

const MoneyInput: React.FC<IMoneyInputProps> = ({
	value,
	readonly,
	changeHandler,
	currency = Currency.Ruble,
}: IMoneyInputProps) => {
	const [inputValue, setInputValue] = useState<number>(value || 0);

	const currencyIcon = useWalletIcon(currency, true);

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		const inputValue = e.target.value.replace(/\D/g, '');

		if (inputValue.length === 0) {
			setInputValue(0);
			if (changeHandler) {
				changeHandler(0);
			}
			return;
		}

		setInputValue(parseInt(inputValue));
		if (changeHandler) {
			changeHandler(parseInt(inputValue));
		}
	};

	useEffect(() => {
		setInputValue(value ?? 0);
	}, [value]);

	return (
		<StyledContainer
			onMouseEnter={() => {
				if (!readonly) {
					playSound(Sound.LinkCursor);
				}
			}}
		>
			<TextInput
				height={60}
				fontSize={16}
				readOnly={readonly}
				onChange={onChange}
				value={inputValue.toLocaleString('ru-RU')}
				padding="0 60px 0 20px"
				tabIndex={-1}
			/>
			<CurrencyIcon icon={currencyIcon} size="lg" />
		</StyledContainer>
	);
};

export { MoneyInput };
